import React from 'react'
import {css} from '@emotion/react'
import styled from '@emotion/styled'
import {MeasurementSystemType} from 'types/Localization'

import {Grid} from '@daedalus/atlas/src/components/designSystem/helpers/Grid'
import {StarRating} from '@daedalus/atlas/src/components/designSystem/StarRating'

import {LocationDetails} from './LocationDetails'
import {PropertySummarySkeleton} from './Skeleton'

interface PropertySummaryProps {
  hotelName: string
  starRating: number
  address: string
  distanceFromTarget?: number
  cityName?: string
  distanceUnit: MeasurementSystemType
}

const HotelName = styled.div(
  ({theme}) => css`
    ${theme.typography.text.titleL}
    margin: ${theme.layout.spacing.s200}px 0;
  `
)

const PropertySummaryWrapper = styled(Grid)(
  ({theme}) => css`
    background-color: ${theme.colors.background.neutral.c000};
  `
)

const LocationDetailsWrapper = styled.div(
  ({theme}) => css`
    margin-bottom: ${theme.layout.spacing.s100}px;
  `
)

export const PropertySummary = ({
  hotelName,
  starRating,
  address,
  cityName,
  distanceFromTarget = 0,
  distanceUnit
}: PropertySummaryProps) => {
  // Showing skeleton
  if (!hotelName) return <PropertySummarySkeleton />

  return (
    <PropertySummaryWrapper container>
      <Grid mobileSm={12}>
        <div>
          <StarRating rating={starRating} size="xs" />
        </div>
        <HotelName>{hotelName}</HotelName>
        <LocationDetailsWrapper>
          <LocationDetails
            address={address}
            cityName={cityName}
            distance={distanceFromTarget}
            distanceUnit={distanceUnit}
          />
        </LocationDetailsWrapper>
      </Grid>
    </PropertySummaryWrapper>
  )
}
